import {ReactNode} from 'react';
import {DayOfWeekList} from '../../../graphql/generated/types';
import {useDayOfWeekListQuery} from '../../../wrapper/tabWrapper';
import {DayOfWeekCommonProps, DayOfWeekReferenceKeyProps} from '../type';

interface Props extends DayOfWeekCommonProps, DayOfWeekReferenceKeyProps {
  children: (data: DayOfWeekList) => ReactNode;
}

export const DayOfWeekListContainer = ({
  referenceKey,
  dayId,
  sortType,
  page,
  size,
  children,
}: Props) => {
  const {data} = useDayOfWeekListQuery({
    referenceKey,
    dayUid: dayId,
    sortType,
    page,
    size,
  });

  if (!data) {
    return null;
  }

  return <>{children(data)}</>;
};
